import { cacheDom } from '../utils/QuerySelectors.js'
import { formatPlayerTime } from '../utils/helpers.js'

const dom = {}
const qs = {
  playPause: 'data-play-pause',
  mute: 'data-mute',
  fullscreen: 'data-fullscreen',
  duration: 'data-duration',
  current: 'data-current',
  track: 'data-track',
  road: 'data-road',
  controls: 'data-video-controls',
}
const qsAll = {
  videos: 'data-video-component',
}

const playVideo = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  if(video){    
    video.play()
    videoWrapper.querySelector('.icon-pause').classList.remove('hidden')
    videoWrapper.querySelector('.icon-play').classList.add('hidden')
  }
}

const pauseVideo = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  video.pause()
  videoWrapper.querySelector('.icon-pause').classList.add('hidden')
  videoWrapper.querySelector('.icon-play').classList.remove('hidden')
}
const toggleMute = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  video.muted = !video.muted
  if (video.muted) {
    videoWrapper.querySelector('.icon-mute').classList.remove('hidden')
    videoWrapper.querySelector('.icon-unmute').classList.add('hidden')
  } else {
    videoWrapper.querySelector('.icon-mute').classList.add('hidden')
    videoWrapper.querySelector('.icon-unmute').classList.remove('hidden')
  }
}
const initVideoControls = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  const controls = videoWrapper.querySelector(`[${qs.controls}]`)
  const road = videoWrapper.querySelector(`[${qs.road}]`)
  const playPauseBtn = videoWrapper.querySelector(`[${qs.playPause}]`)
  const muteBtn = videoWrapper.querySelector(`[${qs.mute}]`)
  const fullscreenBtn = videoWrapper.querySelector(`[${qs.fullscreen}]`)
  let videoDuration = 1
  if(muteBtn){    
    muteBtn.addEventListener('click', () => {
      toggleMute(videoWrapper)
    })
  }

  if(fullscreenBtn){  
    fullscreenBtn.addEventListener('click', () => {
      if (document.fullscreenElement) {
        videoWrapper.classList.remove('hero-media--full')
        if (document.exitFullscreen) document.exitFullscreen()
        else if (document.webkitExitFullscreen) /* Safari */ document.webkitExitFullscreen()
        else if (document.msExitFullscreen) /* IE11 */ document.msExitFullscreen()
      } else {
        videoWrapper.classList.add('hero-media--full')
        if (videoWrapper.requestFullscreen) videoWrapper.requestFullscreen()
        else if (videoWrapper.webkitRequestFullscreen) /* Safari */ videoWrapper.webkitRequestFullscreen()
        else if (videoWrapper.msRequestFullscreen) /* IE11 */ videoWrapper.msRequestFullscreen()
      }
    })
  }
  if(playPauseBtn){
    playPauseBtn.addEventListener('click', () => {
      if (video.paused) playVideo(videoWrapper)
      else pauseVideo(videoWrapper)
    })
  }

  if(video){
    video.onloadedmetadata = () => {
      videoDuration = video.duration
      if(videoWrapper.querySelector(`[${qs.duration}]`)){
        videoWrapper.querySelector(`[${qs.duration}]`).innerHTML = formatPlayerTime(video.duration)
      }
    }
  }
  
  setInterval(() => {
    if(videoWrapper.querySelector(`[${qs.current}]`)){
      videoWrapper.querySelector(`[${qs.current}]`).innerHTML = formatPlayerTime(video.currentTime)
    }
    if(videoWrapper.querySelector(`[${qs.track}]`)){
      videoWrapper.querySelector(`[${qs.track}]`).style.width = `${(video.currentTime / videoDuration) * 100.0}%`
    }
  }, 500)

  if(road){
    road.addEventListener('click', (e) => {
      video.currentTime = (videoDuration * e.offsetX) / road.offsetWidth
    })
  }
  if(controls){
    controls.addEventListener('click', (e) => {
      e.stopPropagation()
      e.preventDefault()
    })
  }
  videoWrapper.dataset.inited = true
}

export const setupVideos = () => {
  cacheDom(dom, qs, qsAll)
  window.addEventListener('resize', () => {
    if (window.innerWidth < 768) dom.videos.forEach((videoWrapper) => pauseVideo(videoWrapper))
  })
  window.addEventListener('orientationchange', () => {
    if (window.innerWidth < 768) dom.videos.forEach((videoWrapper) => pauseVideo(videoWrapper))
  })
  dom.videos.forEach((video) => {
    if (!video.dataset.inited) {
      initVideoControls(video)
    }
  })
}
